import React, { useEffect, useState } from 'react';
import Login from './components/Login';
import AgentCabinet from './components/AgentCabinet';
import { authService } from './services/auth';

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const valid = await authService.validateToken();
      if (valid) {
        setIsAuthenticated(true);
      }
      setLoading(false);
    };
    checkAuth();
  }, []);

  const handleAuthSuccess = (masterId) => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
  };

  if (loading) return <div style={{ padding: '20px', textAlign: 'center' }}>Ƞ䱳諠...</div>;
  if (!isAuthenticated) return <Login onAuthSuccess={handleAuthSuccess} />;
  return <AgentCabinet onLogout={handleLogout} />;
} 